import React from 'react';
import { Icon, Dropdown, Button } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const AuditsTableSettingsMenu = ({
  category,
  code,
  isLoading,
  pointingPosition = 'right',
}) => {
  const intl = useIntl();
  const { singleSorting } = Selectors.useAuditsTableSettingsMenu({ category });
  const toggleSingleSorting = Events.useToggleAuditsSingleSorting(category, { code });

  if (isLoading) {
    return (<Button icon="circle outline" basic circular loading />);
  }

  return (
    <Dropdown
      className="aridhia-audits-table-settings-menu"
      icon={null}
      pointing={`top ${pointingPosition}`}
      trigger={(
        <Button
          basic
          circular
          className="aridhia-audits-table-settings-menu-button"
          icon="cog"
          title={intl.formatMessage({ id: 'actions.table.settings.title' })}
        />
      )}
    >
      <Dropdown.Menu>
        <Dropdown.Item as="a" selected={false} onClick={toggleSingleSorting}>
          <Icon name="sort alphabet down" />
          <FormattedMessage id={singleSorting ? 'actions.sort.multiple' : 'actions.sort.single'} />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AuditsTableSettingsMenu;
